
import React from "react"
import { InfoTip } from "@/components/ui/info-tip"
import { useTour } from "@/contexts/TourContext"

export function PageTour() {
  // Wrap the hook usage in a try/catch to gracefully handle when it's used outside of TourProvider
  try {
    const { getCurrentTourSteps, currentTour, endTour, isToursDisabled } = useTour()
    
    // Early return if tours are disabled or there's no current tour
    if (isToursDisabled() || !currentTour) return null
    
    const steps = getCurrentTourSteps()
    
    return (
      <InfoTip 
        steps={steps} 
        autoStart={true}
        onComplete={() => endTour(currentTour)}
        className="fixed bottom-6 right-6 z-50 shadow-lg"
      />
    )
  } catch (error) {
    // If TourProvider is not available, don't render anything
    console.warn("PageTour is being rendered outside of TourProvider")
    return null
  }
}
